import {
  BOOKMARKS_GET_BOOKMARKS_REQUESTED,
} from 'consts/actionTypes';

export default () => ({
  type: BOOKMARKS_GET_BOOKMARKS_REQUESTED,
});
